import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import PluvaAutoObject from '../../../assets/images/pluvaAutoLanding/pluva_auto_main_object.jpg';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';

export const TopSection = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <TitleSection>
        <Title>
          {'트랙터 자율주행 키트\n'}
          <TitleHighlight onClick={() => navigate(pageInfo.pluvaAutoBusinessPage.path)}>
            {'국내 매출액 1위!'}
          </TitleHighlight>
        </Title>
        <TitleHelperText>{'22년~24년 3월 말, 자체매출집계 기준'}</TitleHelperText>
      </TitleSection>
      <Image src={PluvaAutoObject} />
      <Description>
        {'플루바 오토! 판매 1,000대 돌파!\n수익성 개선은 물론,\n부족한 일손까지 완벽 해결하세요!'}
      </Description>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 60px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;
  background: var(--Light-Scheme-Monochrome-black, #232429);
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;
  font-family: Pretendard;
  font-size: 32px;
  font-style: normal;
  font-weight: 800;
  line-height: 120%; /* 38.4px */
  white-space: pre-line;
`;

const TitleHighlight = styled.span`
  color: var(--Light-Scheme-Color-primary-green, #34c77e);
`;

const TitleHelperText = styled.p`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);
  text-align: center;

  /* Display/Small/s-light */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 130%; /* 15.6px */
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* Display/X-Large/xl-regular */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 23.4px */
`;

const Image = styled.img`
  width: 256px;
`;
